import { ComponentPropsWithoutRef, FC } from 'react';

export const ProfileHeightXxlIcon: FC<ComponentPropsWithoutRef<'svg'>> = (props) => (
  <svg width="256" height="400" viewBox="0 0 256 400" fill="none" {...props}>
    <g clipPath="url(#clip0_3109_67713)">
      <path d="M27.4429 289.177C71.6462 289.177 107.538 325.146 107.538 369.445V394.53H27.4429V289.177Z" fill="black" />
      <path
        d="M227.554 400C227.554 371.646 204.621 348.665 176.329 348.665C148.036 348.665 125.104 371.646 125.104 400"
        fill="black"
      />
      <path d="M216.778 198.756L19.4297 241.323L50.8618 141.805L176.42 102.927L216.778 198.756Z" fill="black" />
      <path
        d="M176.535 171.317C176.535 216.781 171.71 253.634 126.345 253.634C80.9794 253.634 44.2051 216.781 44.2051 171.317C44.2051 125.854 80.9794 89 126.345 89C171.71 89 176.535 125.854 176.535 171.317Z"
        fill="black"
      />
      <path
        d="M127.562 386.884C189.728 386.884 240.124 336.38 240.124 274.079C240.124 211.779 189.728 161.274 127.562 161.274C65.3957 161.274 15 211.779 15 274.079C15 336.38 65.3957 386.884 127.562 386.884Z"
        fill="black"
      />
      <path
        d="M59.3616 282.939C64.1926 330.457 97.6752 367.896 140.71 380.11C154.869 384.128 170.025 382.232 182.869 375.043C221.432 353.457 245.642 310.213 240.252 263.616C238.943 252.299 236.607 241.573 232.305 231.634L232.092 231.585L212.866 190.024C203.599 169.341 182.127 156.982 159.633 159.348C159.365 159.378 159.104 159.402 158.836 159.433C97.5718 166.305 53.1129 221.476 59.3616 282.933V282.939Z"
        fill="#B3E0DF"
      />
      <path
        d="M129.661 28.9697H101.131C91.6152 28.9697 83.894 21.238 83.894 11.6953H119.531H146.898C146.898 21.2319 139.183 28.9697 129.661 28.9697Z"
        fill="black"
      />
      <path
        d="M168.747 41.439C166.155 20.622 148.498 5 127.562 5C106.625 5 88.9683 20.622 86.3763 41.439L78.71 102.927C78.71 129.89 100.523 151.75 127.428 151.75H127.702C154.607 151.75 176.42 129.89 176.42 102.927L168.753 41.439H168.747Z"
        fill="white"
      />
      <path
        d="M113.878 45.811H165.584C165.584 55.3415 157.862 63.0854 148.346 63.0854H131.109C121.599 63.0854 113.872 55.3476 113.872 45.811H113.878Z"
        fill="black"
      />
      <path
        d="M119.962 73.5H171.668V82.2073C171.668 96.5061 160.083 108.116 145.815 108.116C131.547 108.116 119.962 96.5061 119.962 82.2073V73.5Z"
        fill="#B3E0DF"
      />
      <path
        d="M171.449 63.0853C171.449 77.3963 171.668 100.049 145.815 100.049C131.535 100.049 119.962 88.4512 119.962 74.1402C119.962 69.7561 121.052 65.1646 122.968 60.9085C128.986 47.5671 145.937 43.4451 157.522 52.3658L171.449 63.0853Z"
        fill="white"
      />
      <path
        d="M168.51 61.7622C168.51 66.9146 164.342 71.0915 159.201 71.0915C154.059 71.0915 149.892 66.9146 149.892 61.7622"
        fill="black"
      />
      <path
        d="M27.5703 400C27.5703 371.646 50.5025 348.665 78.7951 348.665C107.088 348.665 130.02 371.646 130.02 400"
        fill="black"
      />
      <path d="M83.894 10.7559C83.894 21.3351 92.4548 29.9144 103.011 29.9144V10.7559H83.894Z" fill="black" />
      <path
        d="M232.306 231.634L232.093 231.585L212.866 190.024C203.599 169.341 182.127 156.982 159.633 159.348C159.365 159.378 159.104 159.402 158.836 159.433C103.084 165.689 61.2601 211.939 58.8872 266.53C58.9846 268.738 59.1367 270.957 59.3618 273.183C64.1928 320.701 97.6754 358.14 140.711 370.354C154.869 374.372 170.025 372.476 182.87 365.287C216.462 346.482 239.157 311.244 240.891 271.671C240.775 269 240.568 266.311 240.252 263.61C238.944 252.293 236.607 241.567 232.306 231.628V231.634Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_3109_67713">
        <rect width="226" height="395" fill="white" transform="translate(15 5)" />
      </clipPath>
    </defs>
  </svg>
);
